import { svg } from "@opentiny/vue-common";
var render = function render2() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({
    attrs: {
      "viewBox": "0 0 16 16",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, _vm.$listeners), [_c("path", {
    attrs: {
      "d": "M13 1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10Zm-2.66 4H5.66a.66.66 0 0 0-.653.562L5 5.66v4.68a.66.66 0 0 0 .562.653L5.66 11h4.68a.66.66 0 0 0 .653-.562L11 10.34V5.66a.66.66 0 0 0-.562-.653L10.34 5Z"
    }
  }), _c("path", {
    attrs: {
      "d": "M10.34 5H5.66a.66.66 0 0 0-.653.562L5 5.66v4.68a.66.66 0 0 0 .562.653L5.66 11h4.68a.66.66 0 0 0 .653-.562L11 10.34V5.66a.66.66 0 0 0-.562-.653L10.34 5Z",
      "fill": "#FFF"
    }
  })]);
};
var Halfselect = {
  render
};
var index = function index2() {
  return svg({
    name: "IconHalfselect",
    component: Halfselect
  })();
};
export {
  index as default
};
